import Vue from 'vue'
import Vuex from 'vuex'

// modules
import error from './modules/error'
import site from './modules/site'
import layout from './modules/layout'
import quiz from './modules/quiz'
import nations from './modules/nations'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    error,
    site,
    layout,
    quiz,
    nations
  }
})
